import { Buffer } from 'buffer';
import JSZip from 'jszip';

export const getIconByExtension = (extension: any) => {
    switch (extension.toLowerCase()) {
        case 'pdf':
            return "bi bi-file-pdf pe-1";
        case 'xlsx':
            return "bi bi-filetype-xlsx";
        case 'xls':
            return "bi bi-filetype-xls";
        case 'doc':
        case 'docx':
            return "bi bi-file-word pe-1";
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            return "bi bi-file-image pe-1";
        default:
            return "bi bi-file pe-1";
    }
};

const getMimeType = (extension: string) => {
    switch (extension.toLowerCase()) {
        case 'pdf':
            return 'application/pdf';
        case 'png':
        case 'jpg':
        case 'jpeg':
        case 'gif':
            return `image/${extension.toLowerCase()}`;
        case 'doc':
            return 'application/msword';
        case 'docx':
            return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        case 'xls':
            return 'application/vnd.ms-excel';
        case 'xlsx':
            return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        default:
            return 'application/octet-stream';
    }
};

export const isDisabledPreview = (extension: any) => {
    switch (extension?.toLowerCase()) {
        case 'pdf':
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            return false;
        default:
            return true;
    }
};

export const DownloadFile = (file: any) => {
    const byteArray = Uint8Array.from(Buffer.from(file.Data, 'base64'));
    const blob = new Blob([byteArray], { type: getMimeType(file.Extension) });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${file.Name}_${file.ShipmentNumber}_${file.Identifier}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const DownloadFileFromLink = async (url: string) => {
    window.open(url,'_self');
};


export const PreviewFile = (file: any) => {
        const byteArray = Uint8Array.from(Buffer.from(file.Data, 'base64'));
        const blob = new Blob([byteArray], { type: getMimeType(file.Extension) });
        const url = URL.createObjectURL(blob);

        window.open(url, '_blank');
};

export const PreviewFileFromLink = (url:any,Extension:string) => {
    fetch(url)
    .then((response) => {
        return response.blob();
    })
    .then((blob) => {
        const fileUrl = URL.createObjectURL(new Blob([blob], { type:  getMimeType(Extension) }));
        window.open(fileUrl, '_blank'); // Abre el archivo en una nueva pestaña
    })
};



export const DownloaFilesInZIP = async (files: any, typeOperation: any, NumberOperation: any, typeList: any) => {
    const zip = new JSZip();
    files.forEach((file: any) => {
        const byteArray = Uint8Array.from(Buffer.from(file.Data, 'base64'));
        zip.file(`${file.Name}_${file.ShipmentNumber}_${file.Identifier}.${file.Extension.toLowerCase()}`, byteArray, { base64: true });
    });
    const content = await zip.generateAsync({ type: 'blob' });
    const url = URL.createObjectURL(content);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${typeList}_${typeOperation}_${NumberOperation}.zip`;
    a.click();
    URL.revokeObjectURL(url);
};

export const DownloadFilesInZIPFromlinks = async (files: any[], typeOperation: any, NumberOperation: any, typeList: any) => {
    const zip = new JSZip();
    const fetchFileAsBlob = async (url: string) => {
        const response = await fetch(url);
        return await response.blob();
    };

    for (const file of files) {
        try {
            const blob = await fetchFileAsBlob(file.urlLink); 
            const fileName = `${file.Name}_${file.shipmentNumber}_${file.Identifier}.${file.Extension.toLowerCase()}`;
            zip.file(fileName, blob);
        } catch (error) {
            console.error(`No se pudo agregar el archivo ${file.urlLink}:`, error);
        }
    }

    const content = await zip.generateAsync({ type: 'blob' });
    const url = URL.createObjectURL(content);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${typeList}_${typeOperation}_${NumberOperation}.zip`;
    a.click();
    URL.revokeObjectURL(url);
};

